import { z } from "zod";
export const CrearClienteSchema = z.object({
    nombre: z.string().min(2, "El nombre debe tener al menos 2 caracteres").max(120),
    documento: z.string().max(30).optional().nullable(),
    telefono: z.string().max(30).optional().nullable(),
    direccion: z.string().max(200).optional().nullable(),
    limiteCredito: z.number().min(0, "El límite de crédito no puede ser negativo").default(0),
    activo: z.boolean().optional().default(true),
});
export const EditarClienteSchema = CrearClienteSchema.partial();
export const RegistrarAbonoFiadoSchema = z.object({
    monto: z.number().positive("El monto abonado debe ser un número positivo"),
    medioPago: z.enum(["EFECTIVO", "NEQUI", "BANCOLOMBIA", "TARJETA", "FIADO", "OTRO"]).default("EFECTIVO"),
    referencia: z.string().max(100).optional().nullable(),
    notas: z.string().max(240).optional().nullable(),
});
// ------------------------------------------------------------------
// Respuestas (lo que el backend REALMENTE devuelve). z.coerce.number()
// en los montos por lo mismo de siempre: Prisma serializa `Decimal` como
// string (ver PROGRESS.md sección 5b/7).
// ------------------------------------------------------------------
const MontoCoercible = z.coerce.number();
export const CuentaFiadoItemSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    clienteId: z.string(),
    facturaId: z.string().nullable().optional(),
    monto: MontoCoercible,
    saldo: MontoCoercible,
    descripcion: z.string().nullable().optional(),
    creadoEn: z.string(),
});
export const AbonoFiadoItemSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    clienteId: z.string(),
    usuarioId: z.string(),
    turnoCajaId: z.string().nullable().optional(),
    monto: MontoCoercible,
    medioPago: z.string(),
    referencia: z.string().nullable().optional(),
    notas: z.string().nullable().optional(),
    creadoEn: z.string(),
});
export const ClienteItemSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    nombre: z.string(),
    documento: z.string().nullable().optional(),
    telefono: z.string().nullable().optional(),
    direccion: z.string().nullable().optional(),
    limiteCredito: MontoCoercible,
    saldoPendiente: MontoCoercible,
    activo: z.boolean(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
    _count: z.object({ cuentas: z.number(), abonos: z.number() }).optional(),
});
export const ClienteDetalleItemSchema = ClienteItemSchema.extend({
    cuentas: z.array(CuentaFiadoItemSchema),
    abonos: z.array(AbonoFiadoItemSchema),
});
export const RegistrarAbonoRespuestaSchema = z.object({
    abono: AbonoFiadoItemSchema,
    cliente: ClienteItemSchema,
    saldoAnterior: MontoCoercible,
    nuevoSaldo: MontoCoercible,
});
//# sourceMappingURL=cliente.schema.js.map